export function computeExpansionState(id: string, openIds: Set<string>, parentIds: string[]) {
  const isParentExpanded =
    parentIds.every((parentId) => openIds.has(parentId)) || parentIds.length === 0;
  const isExpanded = openIds.has(id);

  return {
    isParentExpanded,
    isExpanded,
  };
}
